declare namespace $ {

	export class $shm_hitalama_map_widget_float_entity_field_settings extends $mol_pick {
		opened( next?: boolean ): boolean
	}
	
	type $mol_view__sub_shm_hitalama_map_widget_float_entity_field_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_entity_field_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_entity_field_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_string__value_shm_hitalama_map_widget_float_entity_field_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_entity_field['field_name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_form_field__name_shm_hitalama_map_widget_float_entity_field_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_map_widget_float_entity_field_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_entity_field['Field_name'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_select__Filter_shm_hitalama_map_widget_float_entity_field_7 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_select__dictionary_shm_hitalama_map_widget_float_entity_field_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_entity_field['type_dictionary'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_shm_hitalama_map_widget_float_entity_field_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_entity_field['field_type'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_form_field__name_shm_hitalama_map_widget_float_entity_field_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_map_widget_float_entity_field_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_entity_field['Field_type'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_check_box__title_shm_hitalama_map_widget_float_entity_field_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_float_entity_field_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_entity_field['field_required'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_select__Filter_shm_hitalama_map_widget_float_entity_field_14 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_select__dictionary_shm_hitalama_map_widget_float_entity_field_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_entity_field['target_dictionary'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_shm_hitalama_map_widget_float_entity_field_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_entity_field['target_id'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_form_field__name_shm_hitalama_map_widget_float_entity_field_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_map_widget_float_entity_field_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_entity_field['Target'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_select__Filter_shm_hitalama_map_widget_float_entity_field_19 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_select__dictionary_shm_hitalama_map_widget_float_entity_field_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_entity_field['inverse_dictionary'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_shm_hitalama_map_widget_float_entity_field_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_entity_field['inverse_id'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_form_field__name_shm_hitalama_map_widget_float_entity_field_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_map_widget_float_entity_field_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_entity_field['Inverse'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_entity_field_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_entity_field['delete_controls'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__sub_shm_hitalama_map_widget_float_entity_field_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['sub'] >
	>
	type $shm_hitalama_map_widget_float_entity_field_settings__opened_shm_hitalama_map_widget_float_entity_field_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_entity_field['settings_opened'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_entity_field_settings['opened'] >
	>
	type $shm_hitalama_map_widget_float_entity_field_settings__align_shm_hitalama_map_widget_float_entity_field_27 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_map_widget_float_entity_field_settings['align'] >
	>
	type $shm_hitalama_map_widget_float_entity_field_settings__hint_shm_hitalama_map_widget_float_entity_field_28 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_map_widget_float_entity_field_settings['hint'] >
	>
	type $shm_hitalama_map_widget_float_entity_field_settings__trigger_content_shm_hitalama_map_widget_float_entity_field_29 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_map_widget_float_entity_field_settings['trigger_content'] >
	>
	type $shm_hitalama_map_widget_float_entity_field_settings__bubble_content_shm_hitalama_map_widget_float_entity_field_30 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_map_widget_float_entity_field_settings['bubble_content'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_entity_field_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_entity_field_32 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_entity_field_33 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_entity_field['field_delete_ask'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_major__title_shm_hitalama_map_widget_float_entity_field_34 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_hitalama_map_widget_float_entity_field_35 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_entity_field['field_delete_confirm'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_entity_field_36 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_entity_field_37 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_entity_field['field_delete_cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	export class $shm_hitalama_map_widget_float_entity_field extends $shm_hitalama_map_widget_float {
		settings_z_index( ): string
		field_name( next?: string ): string
		Field_title( ): $mol_view
		field_type_title( ): string
		Field_type_title( ): $mol_view
		relation_summary( ): string
		Relation_summary( ): $mol_view
		relation_summary_visible( ): readonly(any)[]
		settings_opened( next?: boolean ): boolean
		Field_settings_icon( ): $mol_icon_dots_vertical
		Field_name( ): $mol_string
		Name_setting( ): $mol_form_field
		type_dictionary( ): Record<string, any>
		field_type( next?: string ): string
		Field_type( ): $mol_select
		Type_setting( ): $mol_form_field
		field_required( next?: boolean ): boolean
		Required( ): $mol_check_box
		target_dictionary( ): Record<string, any>
		target_id( next?: string ): string
		Target( ): $mol_select
		Target_field( ): $mol_form_field
		target_settings( ): readonly(any)[]
		inverse_dictionary( ): Record<string, any>
		inverse_id( next?: string ): string
		Inverse( ): $mol_select
		Inverse_field( ): $mol_form_field
		inverse_settings( ): readonly(any)[]
		delete_controls( ): readonly($mol_view)[]
		Delete_controls( ): $mol_view
		Field_settings_list( ): $mol_list
		Field_settings( ): $shm_hitalama_map_widget_float_entity_field_settings
		Field_row( ): $mol_view
		field_delete_ask( next?: any ): any
		field_delete_confirm( next?: any ): any
		field_delete_cancel( next?: any ): any
		scrollable( ): boolean
		hide_head_tools( ): boolean
		settings_layer( next?: number ): number
		style( ): ({ 
			'zIndex': ReturnType< $shm_hitalama_map_widget_float_entity_field['settings_z_index'] >,
		})  & ReturnType< $shm_hitalama_map_widget_float['style'] >
		head_view( ): readonly(any)[]
		edges( ): readonly(any)[]
		controls( ): readonly(any)[]
		Delete_ask( ): $mol_button_minor
		Delete_confirm( ): $mol_button_major
		Delete_cancel( ): $mol_button_minor
		delete_asked( next?: boolean ): boolean
	}
	
}

//# sourceMappingURL=field.view.tree.d.ts.map